var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteChartBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.75V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H9.75",
    stroke: "#313131",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49749 10.8675L7.28249 8.54999C7.53749 8.21999 8.01 8.16 8.34 8.415L9.71251 9.495C10.0425 9.75 10.515 9.69 10.77 9.3675L12.5025 7.13249",
    stroke: "#313131",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.61 11.865L14.82 12.2925C14.925 12.5025 15.1875 12.6975 15.42 12.7425L15.705 12.7875C16.56 12.93 16.7625 13.56 16.1475 14.1825L15.885 14.445C15.7125 14.625 15.615 14.97 15.6675 15.21L15.705 15.3675C15.9375 16.4025 15.39 16.8 14.49 16.26L14.295 16.1475C14.0625 16.0125 13.6875 16.0125 13.455 16.1475L13.26 16.26C12.3525 16.8075 11.805 16.4025 12.045 15.3675L12.0825 15.21C12.135 14.97 12.0375 14.625 11.865 14.445L11.6025 14.1825C10.9875 13.56 11.19 12.93 12.045 12.7875L12.33 12.7425C12.555 12.705 12.825 12.5025 12.93 12.2925L13.14 11.865C13.545 11.0475 14.205 11.0475 14.61 11.865Z",
    stroke: "#313131",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChartBlack);
export default __webpack_public_path__ + "static/media/favorite-chart-black.1cd0eccba196222256e24048d0292437.svg";
export { ForwardRef as ReactComponent };